<template>
  <div class="c-imagemap">
    <!-- <ion-button
      v-if="selectedMap.includes('head-front')"
      fill="clear"
      size="small"
      @click="selectedMap = genderValue + '-mouth'"
      ><ion-icon
        slot="start"
        :src="require('@lib/assets/icons/tooth.svg')"
      ></ion-icon
      >Zahn-/Kieferbeschwerden</ion-button
    > -->
    <template v-for="(map, key) in maps" :key="key">
      <template v-if="selectedMap === key">
        <div class="c-canvas" id="js-canvas">
          <div
            class="c-marker"
            :class="{ '-red': marker.c === 'red' }"
            v-for="(marker, markerIndex) in markers"
            :key="'marker-' + markerIndex"
            :style="{ left: marker.x + 'px', top: marker.y + 'px' }"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 40 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                opacity="0.8"
                cx="20"
                cy="20"
                r="18.5"
                fill="white"
                stroke-width="3"
              />
              <path
                d="M26.5 20C26.5 23.5898 23.5899 26.5 20 26.5C16.4101 26.5 13.5 23.5898 13.5 20C13.5 16.4102 16.4101 13.5 20 13.5C23.5899 13.5 26.5 16.4102 26.5 20Z"
                stroke="white"
                stroke-width="3"
                @click="markers.splice(markerIndex, 1)"
                class="c-marker__dot"
              />
            </svg>
          </div>
          <img
            :src="require('@lib/assets/img/human/' + key + '.png')"
            :usemap="'#' + key"
            @load="resizeMap"
            id="bodyImage"
            hidefocus="true"
          />
          <canvas class="c-canvas__generated" id="generatedCanvas"></canvas>
          <map :name="key">
            <area
              v-if="map.coords"
              shape="poly"
              :coords="map.coords"
              :href="'#' + key"
              @click.prevent="selectArea($event, key, true)"
              :class="{
                'u-outline': $store.state.isStaging,
              }"
            />
            <template v-else>
              <area
                v-for="(area, areaKey) in map"
                shape="poly"
                :coords="area.coords"
                :key="'area-' + areaKey"
                :href="'#' + areaKey"
                @click.prevent="
                  area.link
                    ? selectArea($event, area.link)
                    : selectArea($event, areaKey)
                "
                :class="{
                  'u-outline': $store.state.isStaging,
                }"
              />
            </template>
          </map>
        </div>
      </template>
    </template>
    <ion-grid class="ion-margin-top">
      <ion-row class="ion-justify-content-center">
        <ion-col
          size="auto"
          v-if="
            !(
              area.includes('mouth') ||
              (zahn && question.type !== 'spreadarea')
            )
          "
        >
          <ion-button :disabled="!canRotate" @click="rotate" fill="outline"
            ><ion-icon :icon="sync" slot="end"></ion-icon>Drehen</ion-button
          >
        </ion-col>
        <ion-col size="auto">
          <ion-button
            fill="outline"
            :disabled="markers.length === 0"
            @click="emitValue()"
            >Weiter</ion-button
          >
        </ion-col>
      </ion-row>
      <ion-button
        v-if="
          question.type !== 'spreadarea' &&
          !area.includes('mouth') &&
          genderValue + '-body' !==
            selectedMap.replace('-front', '').replace('-back', '')
        "
        fill="clear"
        @click="checkMarkers(true) ? reset() : ''"
        size="small"
        >Zur Gesamtansicht</ion-button
      >
    </ion-grid>
  </div>
  <ion-modal
    :is-open="showAdditionalHint"
    css-class="c-autoheight-modal"
    @didDismiss="showAdditionalHint = false"
    :backdropDismiss="false"
  >
    <ion-page>
      <div class="ion-padding modal-content">
        <modal-close />
        <div class="ion-padding-top">
          <p v-if="question.type !== 'spreadarea'">
            Spüren Sie noch an anderen Stellen Schmerzen, die damit
            zusammenhängen? Falls Ja, klicken Sie auf weitere Körperstellen, um
            die Stellen zu markieren. Punkte können durch erneuten Klick darauf
            auch wieder gelöscht werden.
          </p>
          <p v-else>
            Strahlen die Schmerzen noch auf andere Körperstellen aus? Falls Ja,
            klicken Sie auf weitere Körperstellen, um die Stellen zu markieren.
          </p>
        </div>
        <div class="ion-text-right ion-margin-top ion-padding-top">
          <div>
            <ion-button fill="outline" @click="showAdditionalHint = false"
              >Ja</ion-button
            >
          </div>
          <div>
            <ion-button
              fill="outline"
              @click="
                additionalHintShown = true;
                emitValue();
              "
              >Nein</ion-button
            >
          </div>
        </div>
      </div>
    </ion-page>
  </ion-modal>
  <ion-modal
    :is-open="showHeadModal"
    css-class="c-autoheight-modal"
    @didDismiss="showHeadModal = false"
    :backdropDismiss="false"
  >
    <ion-page>
      <div class="ion-padding modal-content">
        <modal-close />
        <h6 class="ion-text-center">
          {{ additionalAnswers["be-2.2"].question.text }}
        </h6>
        <div class="ion-text-right ion-margin-top ion-padding-top">
          <div>
            <ion-button
              fill="outline"
              @click="
                additionalAnswers['be-2.2'].value = 'Zahnbeschwerden';
                showMouth();
              "
              >Zahnbeschwerden</ion-button
            >
          </div>
          <div>
            <ion-button
              fill="outline"
              @click="
                additionalAnswers['be-2.2'].value = 'Zahnfleisch/-hals';
                showMouth();
              "
              >Zahnfleisch/-hals</ion-button
            >
          </div>
          <div>
            <ion-button
              fill="outline"
              @click="
                additionalAnswers['be-2.2'].value = 'Kieferbeschwerden';
                showHeadModal = false;
                painType = 'Kieferbeschwerden';
              "
              >Kieferbeschwerden</ion-button
            >
          </div>
          <div v-if="!zahn">
            <ion-button
              fill="outline"
              @click="
                additionalAnswers['be-2.2'].value = 'Hautbeschwerden';
                showHeadModal = false;
              "
              >Hautbeschwerden</ion-button
            >
          </div>
          <div v-if="!zahn">
            <ion-button
              fill="outline"
              @click="
                additionalAnswers['be-2.2'].value = 'Lippenbeschwerden';
                showHeadModal = false;
              "
              >Lippenbeschwerden</ion-button
            >
          </div>
          <div>
            <ion-button
              fill="outline"
              @click="
                additionalAnswers['be-2.2'].value = 'Andere';
                showHeadModal = false;
              "
              >Andere</ion-button
            >
          </div>
        </div>
      </div>
    </ion-page>
  </ion-modal>
  <ion-modal
    :is-open="showHeartModal"
    css-class="c-autoheight-modal"
    @didDismiss="showHeartModal = false"
    :backdropDismiss="false"
  >
    <ion-page>
      <div class="ion-padding modal-content">
        <!-- <modal-close /> -->
        <h6 class="ion-text-center">
          {{ additionalAnswers["be-2.1"].question.text }}
        </h6>
        <div class="ion-text-right ion-margin-top ion-padding-top">
          <div>
            <ion-button
              fill="outline"
              @click="
                additionalAnswers['be-2.1'].value = 'Ja';
                showHeartModal = false;
              "
              >Ja</ion-button
            >
          </div>
          <div>
            <ion-button
              fill="outline"
              @click="
                additionalAnswers['be-2.1'].value = 'Nein';
                setSelectedArea(genderValue + '-torso-front');
                showHeartModal = false;
              "
              >Nein</ion-button
            >
          </div>
        </div>
      </div>
    </ion-page>
  </ion-modal>
  <ion-modal
    :is-open="showResetModal"
    css-class="c-autoheight-modal"
    @didDismiss="showResetModal = false"
  >
    <ion-page>
      <div class="ion-padding modal-content">
        <modal-close />
        <h6 class="ion-text-center">
          Möchten Sie die Seite wirklich verlassen? Ihre bisher eingegebenen
          Daten gehen dadurch verloren.
        </h6>
        <div class="ion-text-center ion-margin-top ion-padding-top">
          <ion-button
            @click="
              reset();
              showResetModal = false;
            "
            >Ja</ion-button
          >
          <ion-button @click="showResetModal = false">Nein</ion-button>
        </div>
      </div>
    </ion-page>
  </ion-modal>
  <!-- <ion-modal
    :is-open="showMarkersModal"
    css-class="c-autoheight-modal"
    @didDismiss="showMarkersModal = false"
  >
    <ion-page>
      <div class="ion-padding modal-content">
        <modal-close />
        <h6 class="ion-text-center">
          Bitte löschen Sie zuerst Ihre bestehenden Schmerzpunkte mit Klick auf
          die jeweiligen Punkte.
        </h6>
        <div class="ion-text-right ion-margin-top ion-padding-top">
          <div>
            <ion-button fill="outline" @click="showMarkersModal = false"
              >Ok</ion-button
            >
          </div>
        </div>
      </div>
    </ion-page>
  </ion-modal> -->
</template>

<script>
import {
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  IonModal,
  IonPage,
  modalController,
  // IonContent,
} from "@ionic/vue";
import { sync } from "ionicons/icons";
import ModalClose from "@lib/components/ModalClose";
import AlertModal from "@/components/AlertModal";

// ADULT
// MAN
const adultBodyHead = {
  coords:
    "613.8,396.9 568.1,396.9 483,330.3 483,303.2 461.3,273 455.1,232.8 474.5,211.9 470.6,168.5, 493,101.9 543.4,61.7 586.7,54.7 635.5,63.2 684.3,99.6 704.4,169.3 701.3,211.9 719.9,232.8 716,274.6 692.8,303.2 691.2,325.7",
};
const adultBodyTorso = {
  coords:
    "515.5,422.5 303.4,504.5 409.4,891.6 417.9,1023.2 382.3,1342.2 580,1342.2 580,1271 600.6,1271, 600.6,1342.2 794.2,1342.2 761.7,1018.6 761.7,893.2 877.8,510.7 664.1,419.4",
};
const adultBodyArmLeft = {
  coords:
    "303.4,504.5 249.2,591.2 185.7,1173.4 91.2,1298.8 153.2,1407.2 227.5,1380.9 384.9,802",
};
const adultBodyArmRight = {
  coords:
    "877.8,510.7 921.2,599 989.3,1185.8 1041.9,1224 1077.5,1298.8 1037.3,1397.9 947.5,1373.2, 904.1,1246.2 908.8,1204.4 795.7,781.1",
};
const adultBodyLegLeft = {
  coords: "382.3,1342.2 580,1342.2 580,2387.4 421,2370.3 470.6,2234.1",
};
const adultBodyLegRight = {
  coords: "600.6,1342.2 600.6,2387.4 753.9,2365.7 696.6,2232.5 794.2,1342.2",
};
const adultTorso = {
  coords:
    "435.5,293.5 580.5,310.5 723.5,293.5 723.5,426.5 956.5,531.5 1117.5,592.5 1117.5,847.5,	996.5,1047.5 914.5,1324.5 914.5,1572.5 982.5,2200.5 776.5,2236.5 593.5,2218.5 593.5,2074.5 562.5,2074.5 562.5,2221.5, 358.5,2236.5 177.5,2204.5 253.5,1569.5 253.5,1319.5 168.5,1047.5 30.5,813.5 30.5,590.5 212.5,525.5 434.5,421.5",
};
// const adultHeadMouth = {
//   coords:
//     "574,1782,487,1762,428,1735,395,1671,570,1657,761,1671,726,1727,666,1761",
// };
const adultBodyFront = {
  "arm-right-front": { ...adultBodyArmLeft, link: "arm-front" },
  "arm-left-front": { ...adultBodyArmRight, link: "arm-front" },
  "leg-right-front": { ...adultBodyLegLeft, link: "leg-front" },
  "leg-left-front": { ...adultBodyLegRight, link: "leg-front" },
};
const adultBodyBack = {
  "arm-left-back": { ...adultBodyArmLeft, link: "arm-back" },
  "arm-right-back": { ...adultBodyArmRight, link: "arm-back" },
  "leg-left-back": { ...adultBodyLegLeft, link: "leg-back" },
  "leg-right-back": { ...adultBodyLegRight, link: "leg-back" },
};
// END MAN

// WOMAN
const womanBodyHead = {
  coords:
    "596,74.1 524,99.6 472.9,178.6 472.9,262.2 454.3,278.5 470.6,334.2 489.2,345.8 510.1,389.9, 537.9,413.2 537.9,464.3 640.1,464.3 640.1,417.8 661,396.9 686.6,350.5 712.1,329.5 723.7,283.1 705.2,257.5 705.2,185.5, 663.4,97.3",
};
const womanBodyTorso = {
  coords:
    "440.4,506.1 426.5,698.8 472.9,933.4 373,1119.3 398.6,1250.9 580,1250.9 580,1224 603,1224, 603,1250.9 786.5,1250.9 798.1,1121.6 707.5,919.5 751.6,705.8 742.3,506.1 640.1,464.3 537.9,464.3",
};
const womanBodyArmLeft = {
  coords:
    "442.7,506.1 366.1,571.1 270.8,1137.8 224.4,1175 194.2,1247 226.7,1344.5 305.7,1314.3 340.5,1202.8, 333.5,1161 405.5,954.3 442.7,729",
};
const womanBodyArmRight = {
  coords:
    "740,506.1 816.6,571.1 911.9,1137.8 958.3,1175 988.5,1247 956,1344.5 877,1314.3 842.2,1202.8, 849.2,1161 777.2,954.3 740,729",
};
const womanBodyLegLeft = {
  coords: "387,1224 580,1224 580,2375.7 454.3,2347.9 507.7,2250.3 442.7,1836.9",
};
const womanBodyLegRight = {
  coords:
    "793.7,1224 600.6,1224 600.6,2375.7 726.3,2347.9 672.9,2250.3 737.9,1836.9",
};
const womanTorso = {
  coords:
    "705,108 456,108 456,300 144,408 10,530 44.122,782.214 240,1020 276,1488 126.216,1810.83, 72,2148 300,2316 540,2316 540,2172 624,2172 624,2316 876,2316 1104,2148 1051.494,1810.334 900,1476 936,1032 1096.683,769.13, 1138,506 972,384 705,300",
};
// const womanHeadMouth = {
//   coords:
//     "576,1832,483,1803,427,1760,405,1695,584,1698,755,1689,738,1745,673,1803",
// };
const womanBodyFront = {
  "arm-right-front": { ...womanBodyArmLeft, link: "woman-arm-front" },
  "arm-left-front": { ...womanBodyArmRight, link: "woman-arm-front" },
  "leg-right-front": { ...womanBodyLegLeft, link: "woman-leg-front" },
  "leg-left-front": { ...womanBodyLegRight, link: "woman-leg-front" },
};
const womanBodyBack = {
  "arm-left-back": { ...womanBodyArmLeft, link: "woman-arm-back" },
  "arm-right-back": { ...womanBodyArmRight, link: "woman-arm-back" },
  "leg-left-back": { ...womanBodyLegLeft, link: "woman-leg-back" },
  "leg-right-back": { ...womanBodyLegRight, link: "woman-leg-back" },
};
// END WOMAN
// const adultHead = {
//   coords:
//     "579.928,451.74 266.789,550.75 86.771,811.776 68.769,1153.811 0,1223.847 0,1333.829, 104.772,1531.849 167.779,1702.865 239.786,1792.875 239.786,2116.907 914.854,2116.907 914.854,1783.874 977.859,1720.867, 1049.867,1531.849 1159.855,1333.829 1159.855,1223.847 1076.869,1126.808 1058.868,775.773 887.851,541.75",
// };
const mouth = {
  coords:
    "577,588,733,600,847,636,937,683,1008,743,1061,807,1099,882,1120,958,1127,1012,1118,1171,1108,1323,1088,1439,1066,1526,1051,1564,985,1651,929,1702,868,1755,796,1798,721,1831,643,1854,570,1857,492,1847,404,1818,319,1769,236,1708,170,1641,113,1574,88,1500,67,1402,51,1291,43,1185,35,1077,36,1006,47,913,75,836,127,759,202,687,306,634,427,599",
  // "teeth-top": {
  //   coords:
  //     "42,1121,169,1119,174,1088,256,1075,272,1015,261,964,393,909,515,884,647,886,749,907,896,963,904,1064,984,1086,987,1117,1114,1112,1082,933,964,762,754,638,520,616,334,665,171,787,73,938",
  // },
  // "teeth-bottom": {
  //   coords:
  //     "44,1132,171,1132,176,1165,254,1181,272,1223,259,1292,415,1316,614,1321,771,1313,898,1290,899,1218,921,1179,982,1166,992,1135,1119,1132,1044,1363,925,1489,756,1585,513,1611,287,1536,152,1415,70,1277",
  // },
};
// END ADULT

// CHILD
const childBodyHead = {
  coords:
    "591,638,480,677,438,714,418,770,395,879,401,922,492,1039,492,1072,670,1070,668,1040,763,926,767,869,734,706,675,658",
};
const childBodyTorso = {
  coords:
    "493,1072,432,1111,344,1146,392,1291,380,1587,383,1815,568,1817,568,1780,587,1778,587,1817,775,1826,780,1592,768,1288,812,1145,717,1105,667,1072",
};
const childBodyArmLeft = {
  coords:
    "393,1291,234,1715,217,1800,187,1813,136,1768,134,1689,185,1613,271,1263,283,1203,315,1167,331,1154",
};
const childBodyArmRight = {
  coords:
    "764,1289,922,1712,938,1800,968,1815,1009,1778,1027,1727,1017,1671,971,1614,889,1268,880,1217,861,1180,829,1156,812,1145",
};
const childBodyLegLeft = {
  coords:
    "382,1810,396,2015,429,2255,446,2342,418,2362,373,2377,325,2383,294,2399,273,2427,278,2444,561,2446,571,2422,566,2360,566,1817",
};
const childBodyLegRight = {
  coords:
    "589,1821,589,2360,579,2414,592,2446,875,2444,879,2421,840,2388,760,2375,709,2343,748,2087,772,1832",
};
const childHead = {
  coords:
    "560,520,331,596,234,676,154,753,116,843,92,1044,40,1252,51,1396,100,1457,193,1579,243,1664,340,1757,340,1853,284,1925,195,1971,132,1999,185,2091,250,2133,363,2169,505,2190,662,2188,803,2172,932,2117,1013,2046,1027,2001,884,1932,835,1889,819,1857,819,1759,912,1668,976,1563,1090,1436,1119,1348,1115,1238,1065,1018,1002,740,887,601,726,524",
};
const childTorso = {
  coords:
    "449,518,442,568,386,620,268,681,141,721,71,768,15,849,0,938,218,1104,208,1466,214,1798,248,2184,563,2187,568,1914,596,1912,599,2183,915,2189,941,1935,951,1535,943,1105,1159,946,1134,831,1063,745,874,671,737,592,712,521",
};
const childBodyFront = {
  "arm-right-front": childBodyArmLeft,
  "arm-left-front": childBodyArmRight,
  "leg-right-front": childBodyLegLeft,
  "leg-left-front": childBodyLegRight,
};
const childBodyBack = {
  "arm-left-back": childBodyArmLeft,
  "arm-right-back": childBodyArmRight,
  "leg-left-back": childBodyLegLeft,
  "leg-right-back": childBodyLegRight,
};
// END CHILD

// DEFAULT BODY PARTS
const handFingerRightTop = {
  coords:
    "334.3,1628.6 0,1142.5 89.7,1021.7 346.7,1269.4 371.5,492.1 520.1,492.1 544.9,1133.2 580,414.7, 746.2,414.7 758.6,1170.3 792.6,489 972.3,492.1 947.5,1164.1 1015.6,702.7 1160,708.9 1099.2,1269.4 544.9,1269.4",
};
const handPalmRightTop = {
  coords:
    "334.3,1628.6 544.9,1269.4 1099.2,1269.4 1099.2,1563.6 969.2,1833 969.2,2034.3 448.9,2034.3, 448.9,1811.4",
};
const handFingerLeftTop = {
  coords:
    "825.7,1628.6 1160,1142.5 1070.3,1021.7 813.3,1269.4 788.5,492.1 639.9,492.1 615.1,1133.2, 580,414.7 413.8,414.7 401.4,1170.3 367.4,489 187.7,492.1 212.5,1164.1 144.4,702.7 0,708.9 60.8,1269.4 615.1,1269.4",
};
const handPalmLeftTop = {
  coords:
    "825.7,1628.6 615.1,1269.4 60.8,1269.4 60.8,1563.6 190.8,1833 190.8,2034.3 711.1,2034.3, 711.1,1811.4",
};
const legUpperRightFront = {
  coords: "761.7,86.5 421,52.4 383.9,532.4 572.8,2121 736.9,2121",
};
const legFootRightTop = {
  coords: "554.2,2121 433.4,2393.5 783.4,2393.5 736.9,2121",
};
const legUpperLeftFront = {
  coords: "398.3,86.5 739,52.4 776.1,532.4 587.2,2121 423.1,2121",
};
const legFootLeftTop = {
  coords: "605.8,2121 726.6,2393.5 376.6,2393.5 423.1,2121",
};
// END DEFAULT BODY PARTS

export default {
  emits: ["done", "showInfoAlt"],
  components: {
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    IonIcon,
    IonModal,
    IonPage,
    // IonContent,
    ModalClose,
  },
  props: {
    question: {
      required: true,
      type: Object,
    },
    area: {
      required: true,
      type: String,
    },
    genderValue: {
      required: true,
      type: String,
    },
    // zahn: {
    //   required: false,
    //   type: Boolean,
    //   default: false,
    // },
    herzDiabetes: {
      required: false,
      type: Boolean,
      default: false,
    },
    selectedCondition: {
      required: false,
      type: Object,
      default: () => {
        return {};
      },
    },
    answersObject: {
      required: false,
      type: Object,
      default: () => {
        return {};
      },
    },
    shouldStepBack: {
      required: false,
      type: Boolean,
    },
  },
  setup() {
    return { sync };
  },
  mounted() {
    console.log("ImageMap mounted");
    this.$emit("showInfoAlt", false);
    // this.selectedMap = this.area;
    if (this.markers.length === 0) {
      let selectedMap = this.area;
      if (!this.maps[selectedMap]) {
        selectedMap = selectedMap.replace("woman-", "");
        selectedMap = selectedMap.replace("man-", "");
      }
      this.selectedMap = selectedMap;
      if (
        this.question.type !== "spreadarea" &&
        this.selectedCondition.name?.startsWith("tooth")
      ) {
        this.showHeadModal = true;
        this.isHeadModalDisabled = true;
      }
    } else if (
      this.markers.length > 1 &&
      !this.$store.state.isImageMapChanged
    ) {
      modalController
        .create({
          component: AlertModal,
          cssClass: "c-autoheight-modal",
          componentProps: {
            message:
              "Klicken Sie einfach den Schmerzpunkt an, den Sie neu setzen möchten. Er wird dann gelöscht und Sie können einen neuen Schmerzpunkt setzen.",
            buttons: ["Ok"],
          },
        })
        .then((modal) => {
          modal.present();
          this.$store.commit("setIsImageMapChanged", true);
        });
    }
    console.log("area", this.area);
    console.log("selectedMap", this.selectedMap);
  },
  watch: {
    shouldStepBack(val) {
      if (val) {
        const selectedMapHistory = [...this.painareaSelectedMapHistory];
        if (selectedMapHistory.length) {
          this.selectedMap = selectedMapHistory.pop();
          this.setPainareaSelectedMapHistory(selectedMapHistory);
          if (this.selectedMap.includes("-body-front")) {
            this.$emit("showInfoAlt", false);
          }
        }
      }
    },
    selectedMap(newVal) {
      this.selectedArea = "";
      // this.markers = [];
      this.$store.commit("set" + this.questionTypeCapitalized, {
        selectedMap: newVal,
        selectedArea: "",
        markers: [],
      });
    },
    // showAdditionalHint(newVal) {
    //   if (newVal) {
    //     this.additionalHintShown = true;
    //   }
    // },
    // showHeadModal(newVal) {
    //   if (!newVal && this.markers.length === 1) {
    //     this.showAdditionalHint = true;
    //   }
    // },
    // showHeartModal(newVal) {
    //   if (!newVal && this.markers.length === 1) {
    //     this.showAdditionalHint = true;
    //   }
    // },
  },
  methods: {
    setPainareaSelectedMapHistory(value) {
      if (this.question.type === "painarea") {
        this.$store.commit("setPainareaSelectedMapHistory", value);
      }
    },
    setSelectedArea(area) {
      this.selectedArea = area;
      this.$store.commit("set" + this.questionTypeCapitalized, {
        ...this.$store.state[this.question.type],
        selectedArea: this.selectedArea,
      });
    },
    showMouth() {
      this.setPainareaSelectedMapHistory([
        ...this.painareaSelectedMapHistory,
        this.selectedMap,
      ]);
      this.selectedMap = this.genderValue + "-mouth";
      this.showHeadModal = false;
    },
    async emitValue() {
      if (this.markers.length === 1 && !this.additionalHintShown) {
        this.showAdditionalHint = true;
      } else if (
        this.question.type !== "spreadarea" &&
        this.markers[0].c !== "red"
      ) {
        const modal = await modalController.create({
          component: AlertModal,
          cssClass: "c-autoheight-modal",
          componentProps: {
            message:
              "Bitte wählen Sie zuerst einen Hauptschmerzpunkt. Dieser wird durch die Farbe Rot gekennzeichnet.",
            buttons: ["Ok"],
          },
        });
        return modal.present();
      } else {
        var c = document.getElementById("generatedCanvas");
        var img = document.getElementById("bodyImage");
        c.width = img.width;
        c.height = img.height;
        var ctx = c.getContext("2d");
        // ctx.imageSmoothingEnabled = false;
        ctx.drawImage(img, 0, 0, img.width, img.height);
        for (const marker of this.markers) {
          ctx.fillStyle = marker.c === "red" ? "#ee7370" : "#328bf5";
          ctx.fillRect(
            marker.x - img.offsetLeft - 5,
            marker.y - img.offsetTop - 5,
            10,
            10
          );
        }
        this.$emit("showInfoAlt", false);
        const emitValues = [
          {
            value: this.$store.state[this.question.type].selectedArea,
            base64: c.toDataURL(),
            id: this.question.id,
            painType: this.painType,
          },
        ];
        for (const additionalAnswer of Object.values(this.additionalAnswers)) {
          if (additionalAnswer.value !== "") {
            emitValues.push(additionalAnswer);
          }
        }
        this.$emit("done", emitValues);
      }
    },
    resizeMap() {
      setTimeout(() => {
        imageMapResize();
      }, 500);
    },
    selectArea(event, areaKey, isDone = false) {
      if (
        this.question.type !== "spreadarea" &&
        areaKey.includes("body-front-heart")
      ) {
        areaKey = this.genderValue + "-torso-front";
      }
      console.log(areaKey);
      if (
        !isDone &&
        this.maps[areaKey] &&
        this.question.type !== "spreadarea" &&
        this.markers.length === 0
      ) {
        this.setPainareaSelectedMapHistory([
          ...this.painareaSelectedMapHistory,
          this.selectedMap,
        ]);
        this.selectedMap = areaKey;
        this.$emit("showInfoAlt", true);
      } else {
        this.selectedArea = areaKey;
        if (this.markers.length < 5) {
          this.drawPoint(event);
        }
        let shouldShowAdditionalHint = this.markers.length === 1;
        if (this.question.type !== "spreadarea") {
          if (
            areaKey.includes("head-front-mouth") &&
            this.markers.length === 1 &&
            !this.isHeadModalDisabled
          ) {
            this.showHeadModal = true;
            shouldShowAdditionalHint = false;
          }
        }
        if (
          areaKey.includes("-heart") &&
          // !this.zahn &&
          // !this.herzDiabetes &&
          (!this.answersObject["be-2.1"] ||
            this.question.type !== "spreadarea") &&
          this.markers.length === 1
        ) {
          this.showHeartModal = true;
          shouldShowAdditionalHint = false;
        }
        if (shouldShowAdditionalHint && !this.additionalHintShown) {
          this.showAdditionalHint = true;
        }
      }
    },
    checkMarkers(toOverview = false) {
      if (this.markers.length > 0) {
        // this.showMarkersModal = true;
        let message =
          "Sollten Sie noch weitere Schmerzpunkte an anderen Körperstellen haben, so können Sie diese im nächsten Schritt bei der Frage nach „ausstrahlenden Schmerzen“ angeben.";
        if (this.question.type === "spreadarea") {
          message =
            "Ausstrahlende Schmerzen können nur an der Körpervorderseite oder Körperrückseite angegeben werden. Durch Antippen des bereits markierten Schmerzpunktes können Sie diesen löschen und die Körperseite wechseln.";
        }
        let buttons = ["Ok"];
        if (toOverview) {
          buttons = [
            {
              text: "Zur Gesamtansicht",
              handler: () => {
                modalController.dismiss().then(() => {
                  this.showResetModal = true;
                });
              },
            },
            {
              text: "Weiter",
              handler: () => {
                modalController.dismiss().then(() => {
                  this.emitValue();
                });
              },
            },
          ];
        }
        modalController
          .create({
            component: AlertModal,
            cssClass: "c-autoheight-modal",
            componentProps: {
              message: message,
              buttons: buttons,
            },
          })
          .then((modal) => {
            modal.present();
          });

        return false;
      }
      return true;
    },
    reset() {
      // if (this.checkMarkers()) {
      this.selectedMap = this.genderValue + "-body-front";
      this.$store.commit("setPainareaSelectedMapHistory", []);
      this.$emit("showInfoAlt", false);
      // }
    },
    rotate() {
      if (this.checkMarkers()) {
        if (
          this.selectedMap.includes("foot-right-top") ||
          this.selectedMap.includes("foot-left-top") ||
          this.selectedMap.includes("foot-top")
        ) {
          this.selectedMap = this.selectedMap.replace("-top", "-back");
        } else if (
          this.selectedMap.includes("foot-right-back") ||
          this.selectedMap.includes("foot-left-back") ||
          this.selectedMap.includes("foot-back")
        ) {
          this.selectedMap = this.selectedMap.replace("-back", "-top");
        } else if (this.selectedMap.includes("-front")) {
          this.selectedMap = this.selectedMap.replace("-front", "-back");
        } else if (this.selectedMap.includes("-back")) {
          this.selectedMap = this.selectedMap.replace("-back", "-front");
        } else if (this.selectedMap.includes("-top")) {
          this.selectedMap = this.selectedMap.replace("-top", "-bottom");
        } else if (this.selectedMap.includes("-bottom")) {
          this.selectedMap = this.selectedMap.replace("-bottom", "-top");
        }
      }
    },
    drawPoint(event) {
      console.log(event);
      // const x = event.layerX;
      // const y = event.layerY;

      const canvas = document
        .getElementById("js-canvas")
        .getBoundingClientRect();
      console.log(canvas);
      const x = event.clientX - canvas.left;
      const y = event.clientY - canvas.top;
      const c =
        this.question.type !== "spreadarea" &&
        (this.markers.length === 0 || this.markers[0].c) !== "red"
          ? "red"
          : "blue";
      let newMarkers = [];
      let newSelectedArea = "";
      if (c === "red") {
        newMarkers = [{ x: x, y: y, c: c }, ...this.markers];
        newSelectedArea = this.selectedArea;
      } else {
        newMarkers = [...this.markers, { x: x, y: y, c: c }];
        newSelectedArea = this.$store.state[this.question.type].selectedArea;
      }

      // this.markers = [{ x: x, y: y }];
      // this.markers.push({ x: x, y: y });
      this.$store.commit("set" + this.questionTypeCapitalized, {
        selectedMap: this.selectedMap,
        selectedArea: newSelectedArea,
        markers: newMarkers,
      });
    },
  },
  computed: {
    painareaSelectedMapHistory() {
      return this.$store.state.painareaSelectedMapHistory;
    },
    zahn() {
      return (
        this.selectedCondition.name?.startsWith("tooth") ||
        this.answersObject["be-15"] === "X" ||
        this.answersObject["be-15.1"] === "X" ||
        this.answersObject["fa-2"] === "zahn" ||
        this.answersObject["be-15"] === "kiefer" ||
        this.answersObject["be-15.1"] === "kiefer" ||
        this.answersObject["fa-2"] === "kiefer"
      );
    },
    questionTypeCapitalized() {
      return (
        this.question.type.charAt(0).toUpperCase() + this.question.type.slice(1)
      );
    },
    markers() {
      return this.$store.state[this.question.type].markers;
    },
    canRotate() {
      if (
        this.selectedMap.includes("-front") ||
        this.selectedMap.includes("-back") ||
        this.selectedMap.includes("-top") ||
        this.selectedMap.includes("-bottom")
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      selectedMap: this.$store.state[this.question.type].selectedMap,
      selectedArea: this.$store.state[this.question.type].selectedArea,
      // markers: [],
      showHeadModal: false,
      isHeadModalDisabled: false,
      painType: "",
      showHeartModal: false,
      showAdditionalHint: false,
      additionalHintShown: false,
      showResetModal: false,
      // showMarkersModal: false,
      additionalAnswers: {
        "be-2.1": {
          id: "be-2.1",
          value: "",
          isAdditionalAnswer: true,
          question: {
            id: "be-2.1",
            text: "Haben Sie Herzbeschwerden?",
            isAdditionalQuestion: true,
          },
        },
        "be-2.2": {
          id: "be-2.2",
          value: "",
          isAdditionalAnswer: true,
          question: {
            id: "be-2.2",
            text: "Um welche Art von Beschwerden handelt es sich?",
            isAdditionalQuestion: true,
          },
        },
      },
      maps: {
        // MAN
        "man-body-front": {
          ...adultBodyFront,
          "man-head-front": { ...adultBodyHead },
          "man-body-front-heart": {
            coords:
              "555,513,550,799,789,807,807,744,842,697,861,639,871,577,872,524,860,497,772,469,628,493",
          },
          "man-torso-front": { ...adultBodyTorso },
        },
        "man-body-back": {
          ...adultBodyBack,
          "man-head-back": { ...adultBodyHead },
          "man-torso-back": { ...adultBodyTorso },
        },
        "man-body-upper-front": {
          "man-body-upper-front-heart": {
            coords:
              "574,546,538,544,531,877,819,888,836,816,905,531,804,493,622,519",
          },
          "man-body-upper-front-around": {
            coords:
              "577,0,653,10,704,61,724,130,716,184,729,190,741,227,718,283,700,318,674,360,675,430,931,535,966,602,969,700,988,885,1025,1094,1056,1322,1110,1372,1157,1468,1150,1484,1117,1481,1129,1556,1117,1582,1076,1593,1011,1570,970,1480,872,1112,833,854,792,981,786,1141,823,1373,824,1612,332,1615,333,1344,373,1148,365,980,326,838,290,1103,181,1490,152,1568,68,1595,31,1561,37,1481,6,1485,-1,1465,46,1373,102,1324,135,1081,167,834,184,624,212,554,285,507,485,429,486,364,451,319,426,263,416,212,425,190,436,182,431,115,464,41,514,5",
          },
        },
        "man-body-upper-back": {
          coords:
            "577,0,653,10,704,61,724,130,716,184,729,190,741,227,718,283,700,318,674,360,675,430,931,535,966,602,969,700,988,885,1025,1094,1056,1322,1110,1372,1157,1468,1150,1484,1117,1481,1129,1556,1117,1582,1076,1593,1011,1570,970,1480,872,1112,833,854,792,981,786,1141,823,1373,824,1612,332,1615,333,1344,373,1148,365,980,326,838,290,1103,181,1490,152,1568,68,1595,31,1561,37,1481,6,1485,-1,1465,46,1373,102,1324,135,1081,167,834,184,624,212,554,285,507,485,429,486,364,451,319,426,263,416,212,425,190,436,182,431,115,464,41,514,5",
        },
        "man-head-front": {
          // "man-mouth": { ...adultHeadMouth },
          "man-head-upper-front": {
            coords:
              "558,461,400,485,265,549,173,640,106,764,78,883,72,973,84,1170,100,1354,1063,1350,1076,1164,1088,983,1083,887,1054,765,979,627,872,534,718,473",
          },
          "man-head-front-mouth": {
            coords:
              "581,1575,109,1543,121,1625,167,1710,233,1783,243,1820,920,1822,930,1782,990,1712,1032,1635,1051,1547",
          },
          "man-head-front-around": {
            coords:
              "579.928,451.74 266.789,550.75 86.771,811.776 68.769,1153.811 0,1223.847 0,1333.829, 104.772,1531.849 167.779,1702.865 239.786,1792.875 239.786,2116.907 914.854,2116.907 914.854,1783.874 977.859,1720.867, 1049.867,1531.849 1159.855,1333.829 1159.855,1223.847 1076.869,1126.808 1058.868,775.773 887.851,541.75",
          },
        },
        "man-mouth": {
          ...mouth,
        },
        "man-head-back": {
          coords:
            "9,1781,1152,1772,836,1624,823,1412,884,1319,913,1230,975,1169,982,1141,1000,1069,999,997,974,957,947,944,934,769,886,612,761,497,595,456,439,474,315,547,241,668,220,758,213,942,189,960,167,999,164,1088,187,1167,245,1231,272,1311,315,1388,332,1413,335,1615,3,1771",
        },
        "man-torso-front": {
          "man-torso-front-heart": {
            coords:
              "576,610,651,566,885,537,958,532,1123,594,1136,681,1133,772,1113,871,1070,958,999,1041,971,1144,505,1145,514,605",
          },
          "man-torso-front-around": { ...adultTorso },
        },
        "man-torso-back": {
          coords:
            "578,2196,685,2235,811,2238,928,2206,987,2161,979,1981,946,1730,923,1612,924,1424,926,1337,1008,1052,1103,932,1144,798,1147,659,1133,589,1065,548,971,524,838,464,733,421,730,290,763,238,783,176,825,124,836,64,718,70,591,75,472,71,364,56,323,60,342,130,371,173,393,234,426,286,429,409,272,483,196,521,90,554,25,586,12,706,24,826,61,929,147,1037,229,1320,243,1572,221,1717,184,1886,173,2013,168,2157,250,2206,350,2237,479,2231",
        },
        // END MAN

        // WOMAN
        "woman-body-front": {
          ...womanBodyFront,
          "woman-head-front": { ...womanBodyHead },
          "woman-body-front-heart": {
            coords:
              "568,534,548,789,724,791,730,751,747,728,755,700,769,654,781,616,790,574,790,542,742,509,713,499,613,520",
          },
          "woman-torso-front": { ...womanBodyTorso },
        },
        "woman-body-back": {
          ...womanBodyBack,
          "woman-head-back": { ...womanBodyHead },
          "woman-torso-back": { ...womanBodyTorso },
        },
        "woman-body-upper-front": {
          "woman-body-upper-front-heart": {
            coords:
              "485,590,477,919,692,922,702,873,718,851,783,609,748,570,703,548,682,544",
          },
          "woman-body-upper-front-around": {
            coords:
              "517,1,594,17,625,64,662,123,670,242,686,265,671,329,623,405,586,445,594,509,765,577,801,634,850,1013,930,1369,985,1409,1032,1505,1023,1521,994,1514,1010,1598,989,1639,899,1610,856,1507,769,1175,714,862,678,1096,770,1339,785,1492,770,1668,262,1669,244,1505,266,1318,358,1099,318,865,273,1155,192,1405,142,1605,50,1641,18,1589,36,1515,2,1520,0,1489,47,1413,102,1365,149,1152,223,644,295,565,442,504,446,447,402,401,353,323,340,260,361,240,362,153,394,73,456,8",
          },
        },
        "woman-body-upper-back": {
          coords:
            "517,1,594,17,625,64,662,123,670,242,686,265,671,329,623,405,586,445,594,509,765,577,801,634,850,1013,930,1369,985,1409,1032,1505,1023,1521,994,1514,1010,1598,989,1639,899,1610,856,1507,769,1175,714,862,678,1096,770,1339,785,1492,770,1668,262,1669,244,1505,266,1318,358,1099,318,865,273,1155,192,1405,142,1605,50,1641,18,1589,36,1515,2,1520,0,1489,47,1413,102,1365,149,1152,223,644,295,565,442,504,446,447,402,401,353,323,340,260,361,240,362,153,394,73,456,8",
        },
        "woman-head-front": {
          // "woman-mouth": { ...womanHeadMouth },
          "woman-head-upper-front": {
            coords:
              "568,420,426,448,327,507,263,579,228,664,147,766,91,915,72,1021,69,1117,82,1250,113,1426,1060,1428,1088,1251,1097,1073,1088,967,1066,854,1005,728,942,657,906,570,843,496,707,433",
          },
          "woman-head-front-mouth": {
            coords:
              "588,1617,150,1614,190,1716,245,1802,300,1866,356,1910,355,1933,797,1952,795,1931,858,1872,921,1807,977,1718,1019,1608",
          },
          "woman-head-front-around": {
            coords:
              "579.928,416 332,488 224,668 116,848 68,1256 0,1328 0,1436 128,1592 344,1916 344,2204 800,2204, 800,1916 1028,1604 1159.855,1424 1159.855,1310 1076,1223.847 1064,836 956,656 860,512",
          },
        },
        "woman-mouth": {
          ...mouth,
        },
        "woman-head-back": {
          coords:
            "65,1760,1096,1760,941,1710,821,1665,751,1617,741,1429,819,1366,877,1288,904,1222,946,1192,987,1118,997,1021,973,980,946,973,945,811,914,673,834,558,795,456,722,394,618,370,502,376,402,421,346,498,325,565,262,647,217,763,209,973,175,998,159,1042,171,1123,207,1187,258,1220,306,1320,362,1388,415,1430,414,1610,355,1663",
        },
        "woman-torso-front": {
          "woman-torso-front-heart": {
            coords:
              "578,452,640,418,827,392,918,372,1014,409,1083,467,1126,533,1116,632,1081,731,1002,824,991,901,964,970,939,997,925,1103,528,1093,526,450",
          },
          "woman-torso-front-around": { ...womanTorso },
        },
        "woman-torso-back": {
          coords:
            "607,2129,606,2183,669,2195,762,2191,855,2165,944,2112,1030,2031,1023,1924,1010,1826,985,1742,930,1606,854,1420,863,1236,880,1105,907,947,977,903,1036,830,1067,744,1078,684,1036,582,975,514,895,481,748,431,704,397,699,271,740,236,778,191,796,158,381,157,399,196,434,237,478,271,469,404,429,435,255,490,182,534,122,603,98,678,105,734,130,807,178,882,227,921,264,945,299,1105,326,1387,317,1444,259,1575,195,1740,153,1916,147,2027,215,2098,289,2150,376,2187,475,2199,565,2190,559,2130",
        },
        "woman-leg-front": {
          "foot-top": {
            coords:
              "317,2115,226,2339,294,2395,527,2390,532,2303,503,2146,665,2154,634,2388,739,2409,941,2353,836,2129",
          },
          "leg-upper-front": {
            coords:
              "522,84,520,500,488,1247,512,1500,484,1924,497,2111,525,2378,495,2403,402,2404,245,2367,231,2323,334,2123,230,1530,254,1263,185,889,146,484,186,45,332,75,508,80,646,81,650,505,680,1237,657,1503,679,1929,671,2114,638,2363,673,2403,762,2406,933,2354,932,2307,830,2119,936,1519,915,1254,994,854,1023,489,981,49,824,74",
          },
        },
        "woman-leg-back": {
          "foot-back": {
            coords:
              "317,2115,226,2339,294,2395,527,2390,532,2303,503,2146,665,2154,634,2388,739,2409,941,2353,836,2129",
          },
          "leg-upper-back": {
            coords:
              "522,84,520,500,488,1247,512,1500,484,1924,497,2111,525,2378,495,2403,402,2404,245,2367,231,2323,334,2123,230,1530,254,1263,185,889,146,484,186,45,332,75,508,80,646,81,650,505,680,1237,657,1503,679,1929,671,2114,638,2363,673,2403,762,2406,933,2354,932,2307,830,2119,936,1519,915,1254,994,854,1023,489,981,49,824,74",
          },
        },
        "woman-arm-front": {
          "hand-bottom": {
            coords:
              "163,1873,62,1996,4,2215,121,2423,282,2430,364,2337,417,2087,410,1893,740,1898,756,2230,808,2364,912,2422,1034,2420,1153,2202,1084,1991,991,1884",
          },
          "arm-upper-front": {
            coords:
              "433,14,499,568,508,1309,412,1862,423,2004,355,2341,312,2378,253,2422,187,2440,117,2406,97,2362,105,2169,60,2223,11,2221,9,2179,72,1987,116,1922,178,1866,163,1333,205,1125,138,330,173,199,246,99,426,7,726,8,660,587,647,1310,743,1878,728,2015,794,2344,841,2380,890,2420,963,2443,1029,2411,1053,2356,1047,2167,1097,2221,1140,2224,1146,2186,1057,1966,972,1869,988,1328,953,1106,1017,320,986,195,902,89,736,8",
          },
        },
        "woman-arm-back": {
          "hand-top": {
            coords:
              "163,1873,62,1996,4,2215,121,2423,282,2430,364,2337,417,2087,410,1893,740,1898,756,2230,808,2364,912,2422,1034,2420,1153,2202,1084,1991,991,1884",
          },
          "arm-upper-back": {
            coords:
              "433,14,499,568,508,1309,412,1862,423,2004,355,2341,312,2378,253,2422,187,2440,117,2406,97,2362,105,2169,60,2223,11,2221,9,2179,72,1987,116,1922,178,1866,163,1333,205,1125,138,330,173,199,246,99,426,7,726,8,660,587,647,1310,743,1878,728,2015,794,2344,841,2380,890,2420,963,2443,1029,2411,1053,2356,1047,2167,1097,2221,1140,2224,1146,2186,1057,1966,972,1869,988,1328,953,1106,1017,320,986,195,902,89,736,8",
          },
        },
        // END WOMAN

        // BOY
        "boy-body-front": {
          ...childBodyFront,
          "boy-head-front": { ...childBodyHead },
          "boy-torso-front": { ...childBodyTorso },
        },
        "boy-body-back": {
          ...childBodyBack,
          "boy-head-back": { ...childBodyHead },
          "boy-torso-back": { ...childBodyTorso },
        },
        "boy-head-front": { ...childHead },
        "boy-head-back": { ...childHead },
        "boy-torso-front": { ...childTorso },
        "boy-torso-back": { ...childTorso },
        // END BOY

        // GIRL
        "girl-body-front": {
          ...childBodyFront,
          "girl-head-front": { ...childBodyHead },
          "girl-torso-front": { ...childBodyTorso },
        },
        "girl-body-back": {
          ...childBodyBack,
          "girl-head-back": { ...childBodyHead },
          "girl-torso-back": { ...childBodyTorso },
        },
        "girl-head-front": { ...childHead },
        "girl-head-back": { ...childHead },
        "girl-torso-front": { ...childTorso },
        "girl-torso-back": { ...childTorso },
        // END GIRL

        // ARMS
        "arm-front": {
          "hand-bottom": {
            coords:
              "163,1873,62,1996,4,2215,121,2423,282,2430,364,2337,417,2087,410,1893,740,1898,756,2230,808,2364,912,2422,1034,2420,1153,2202,1084,1991,991,1884",
          },
          "arm-upper-front": {
            coords:
              "433,14,499,568,508,1309,412,1862,423,2004,355,2341,312,2378,253,2422,187,2440,117,2406,97,2362,105,2169,60,2223,11,2221,9,2179,72,1987,116,1922,178,1866,163,1333,205,1125,138,330,173,199,246,99,426,7,726,8,660,587,647,1310,743,1878,728,2015,794,2344,841,2380,890,2420,963,2443,1029,2411,1053,2356,1047,2167,1097,2221,1140,2224,1146,2186,1057,1966,972,1869,988,1328,953,1106,1017,320,986,195,902,89,736,8",
          },
        },
        "arm-back": {
          "hand-top": {
            coords:
              "163,1873,62,1996,4,2215,121,2423,282,2430,364,2337,417,2087,410,1893,740,1898,756,2230,808,2364,912,2422,1034,2420,1153,2202,1084,1991,991,1884",
          },
          "arm-upper-back": {
            coords:
              "433,14,499,568,508,1309,412,1862,423,2004,355,2341,312,2378,253,2422,187,2440,117,2406,97,2362,105,2169,60,2223,11,2221,9,2179,72,1987,116,1922,178,1866,163,1333,205,1125,138,330,173,199,246,99,426,7,726,8,660,587,647,1310,743,1878,728,2015,794,2344,841,2380,890,2420,963,2443,1029,2411,1053,2356,1047,2167,1097,2221,1140,2224,1146,2186,1057,1966,972,1869,988,1328,953,1106,1017,320,986,195,902,89,736,8",
          },
        },
        "hand-top": {
          coords:
            "759,533,584,824,478,969,480,1109,136,1113,132,976,76,885,48,765,48,599,15,289,47,239,101,276,148,538,136,160,191,98,247,150,270,490,280,94,337,42,379,88,409,491,431,154,487,101,529,151,540,602,664,487,729,466,896,469,867,533,1043,819,1146,966,1153,1104,1494,1107,1497,976,1549,896,1579,780,1578,600,1614,269,1581,235,1530,265,1481,504,1493,155,1448,85,1391,131,1355,459,1349,82,1300,32,1251,73,1218,495,1198,151,1149,94,1103,134,1096,590,1057,596,959,481,904,464,766,514",
        },
        "hand-bottom": {
          coords:
            "894,248,879,284,917,600,910,790,935,881,968,947,999,980,998,1111,1340,1106,1345,973,1446,829,1625,540,1623,487,1578,468,1529,471,1410,592,1389,124,1348,96,1292,125,1273,438,1240,58,1192,36,1149,76,1135,448,1112,134,1057,92,1014,109,997,166,1007,478,971,276,943,242,906,239,730,243,690,246,663,275,621,498,631,140,589,95,537,105,513,160,496,428,486,85,444,43,399,52,378,94,355,428,343,151,309,108,254,102,234,151,225,590,204,595,99,481,35,464,2,502,9,543,182,826,284,970,283,1107,634,1111,635,976,693,891,723,766,753,295,746,266,739,246",
        },
        // END ARMS

        // LEGS
        "leg-front": {
          "foot-top": {
            coords:
              "317,2115,226,2339,294,2395,527,2390,532,2303,503,2146,665,2154,634,2388,739,2409,941,2353,836,2129",
          },
          "leg-upper-front": {
            coords:
              "522,84,520,500,488,1247,512,1500,484,1924,497,2111,525,2378,495,2403,402,2404,245,2367,231,2323,334,2123,230,1530,254,1263,185,889,146,484,186,45,332,75,508,80,646,81,650,505,680,1237,657,1503,679,1929,671,2114,638,2363,673,2403,762,2406,933,2354,932,2307,830,2119,936,1519,915,1254,994,854,1023,489,981,49,824,74",
          },
        },
        "leg-back": {
          "foot-back": {
            coords:
              "317,2115,226,2339,294,2395,527,2390,532,2303,503,2146,665,2154,634,2388,739,2409,941,2353,836,2129",
          },
          "leg-upper-back": {
            coords:
              "522,84,520,500,488,1247,512,1500,484,1924,497,2111,525,2378,495,2403,402,2404,245,2367,231,2323,334,2123,230,1530,254,1263,185,889,146,484,186,45,332,75,508,80,646,81,650,505,680,1237,657,1503,679,1929,671,2114,638,2363,673,2403,762,2406,933,2354,932,2307,830,2119,936,1519,915,1254,994,854,1023,489,981,49,824,74",
          },
        },
        "foot-top": {
          coords:
            "611,14,618,141,671,269,653,608,684,795,676,1078,582,1137,504,1083,399,1147,248,1104,169,1047,117,910,343,268,326,13,591,12,1022,16,1012,140,961,258,982,595,949,799,959,1084,1053,1130,1126,1067,1222,1149,1382,1100,1463,1050,1515,907,1284,266,1303,17",
        },
        "foot-back": {
          coords:
            "514,19,506,266,578,420,568,599,702,734,707,811,638,888,421,1021,267,1005,120,867,228,714,178,560,242,268,172,23,484,17,1115,17,1117,301,1054,428,1048,638,920,762,933,825,989,880,1175,1009,1359,1005,1513,862,1405,713,1456,544,1387,282,1457,17",
        },
        // END LEGS

        // ARM RIGHT
        "arm-right-front": {
          "arm-upper-right-front": {
            coords:
              "959.9,61.7 724.5,145.3 628.5,306.3 445.8,1854.7 665.7,1901.2 857.7,1309.7 959.9,609.8",
          },
          "hand-right-bottom": {
            coords:
              "665.7,1901.2 445.8,1854.7 343.6,1919.7 229,2139.6 352.9,2399.7 580,2309.9 665.7,2028.1",
          },
        },
        "arm-right-back": {
          "arm-upper-right-back": {
            coords:
              "233.783,55.702 467.806,154.712 580,379.734 746.834,1852.882 521.812,1897.887 332.793,1345.831, 233.783,640.761",
          },
          "hand-right-top": {
            coords:
              "521.812,1897.887 746.834,1852.882 908.851,1969.894 980.857,2140.911 836.844,2410.938, 629.822,2329.93 490.309,1969.894",
          },
        },
        "hand-right-top": {
          "finger-right-top": {
            ...handFingerRightTop,
          },
          "hand-palm-right-top": {
            ...handPalmRightTop,
          },
        },
        "hand-right-bottom": {
          "finger-right-bottom": {
            ...handFingerLeftTop,
          },
          "hand-palm-right-bottom": {
            ...handPalmLeftTop,
          },
        },
        // END ARM RIGHT

        // ARM LEFT
        "arm-left-front": {
          "arm-upper-left-front": {
            coords:
              "233.783,55.702 467.806,154.712 580,379.734 746.834,1852.882 521.812,1897.887 332.793,1345.831, 233.783,640.761",
          },
          "hand-left-bottom": {
            coords:
              "521.812,1897.887 746.834,1852.882 908.851,1969.894 980.857,2140.911 836.844,2410.938, 629.822,2329.93 490.309,1969.894",
          },
        },
        "arm-left-back": {
          "arm-upper-left-back": {
            coords:
              "959.9,61.7 724.5,145.3 628.5,306.3 445.8,1854.7 665.7,1901.2 857.7,1309.7 959.9,609.8",
          },
          "hand-left-top": {
            coords:
              "665.7,1901.2 445.8,1854.7 343.6,1919.7 229,2139.6 352.9,2399.7 580,2309.9 665.7,2028.1",
          },
        },
        "hand-left-top": {
          "finger-left-top": {
            ...handFingerLeftTop,
          },
          "hand-palm-left-top": {
            ...handPalmLeftTop,
          },
        },
        "hand-left-bottom": {
          "finger-left-bottom": {
            ...handFingerRightTop,
          },
          "hand-palm-left-bottom": {
            ...handPalmRightTop,
          },
        },
        // END ARM LEFT

        // LEG RIGHT
        "leg-right-front": {
          "leg-upper-right-front": legUpperRightFront,
          "foot-right-top": legFootRightTop,
        },
        "leg-right-back": {
          "leg-upper-right-back": legUpperLeftFront,
          "foot-right-back": legFootLeftTop,
        },
        "foot-right-top": {
          coords:
            "1018.7,0 387,0 479.9,761.5 0,2015.7 103.6,2071.5 75.7,2224.8 233.7,2275.9 238.3,2345.5 609.9,2448, 749.3,2331.6 944.4,2410.6 1120.9,2359.5 1120.9,1685.9 1028,1224 1102.3,743 963,427.1",
        },
        "foot-right-back": {
          coords:
            "385.2,252.9 1061,252.9 910.1,763.9 1061,1277.2 942.6,1604.6 1149.3,1911.2 842.7,2189.9, 447.9,2189.9 36.8,1829.9 22.8,1658.1 215.6,1525.7 315.5,1356.1 248.1,1096 422.3,701.2",
        },
        // END LEG RIGHT

        // LEGT LEFT
        "leg-left-front": {
          "leg-upper-left-front": legUpperLeftFront,
          "foot-left-top": legFootLeftTop,
        },
        "leg-left-back": {
          "leg-upper-left-back": legUpperRightFront,
          "foot-left-back": legFootRightTop,
        },
        "foot-left-top": {
          coords:
            "141.3,0 773,0 680.1,761.5 1160,2015.7 1056.4,2071.5 1084.3,2224.8 926.3,2275.9 921.7,2345.5, 550.1,2448 410.7,2331.6 215.6,2410.6 39.1,2359.5 39.1,1685.9 132,1224 57.7,743 197,427.1",
        },
        "foot-left-back": {
          coords:
            "774.8,252.9 99,252.9 249.9,763.9 99,1277.2 217.4,1604.6 10.7,1911.2 317.3,2189.9 712.1,2189.9, 1123.2,1829.9 1137.2,1658.1 944.4,1525.7 844.5,1356.1 911.9,1096 737.7,701.2",
        },
        // END LEG LEFT
      },
    };
  },
};
</script>

<style lang="scss">
.c-imagemap {
  // height: 300px;
  // padding: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  height: 100%;

  // Debugging
  area {
    // outline: 1px solid black;
    outline: none;
  }

  // @media screen and (min-width: $breakpoint-lg) {
  //   height: calc(100vh - var(--offset-top) - var(--offset-top) - 210px);
  // }

  img {
    max-height: 100%;
    align-self: center;
  }

  .c-canvas {
    position: relative;
    // height: calc(100% - 70px);
    flex-grow: 1;
    min-height: 200px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    &__generated {
      display: none;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
  }
  .c-marker {
    position: absolute;
    width: 40px;
    height: 40px;
    margin-left: -20px;
    margin-top: -20px;
    // border-radius: 100%;
    // background-color: red;
    &__dot {
      cursor: url("~@lib/assets/icons/trash-outline.svg"), auto;
    }

    circle {
      stroke: #328bf5;
    }
    path {
      fill: #328bf5;
    }

    &.-red {
      circle {
        stroke: #ee7370;
      }
      path {
        fill: #ee7370;
      }
    }
  }
}
</style>
